import { Check, X } from '@lognai/synapse-design-system-v2/icons';
import { describePasswordPolicy, type PasswordPolicy } from '@lognai/plugin-sdk';

/**
 * What the password still needs, shown while it is being typed.
 *
 * The forms used to state one rule in a placeholder ("min 8 characters") and
 * discover the rest from the server's rejection, one at a time, after a round
 * trip (QA ledger AUTH-008).
 */
export function PasswordRequirements({
  policy,
  password,
  className = '',
}: {
  policy: PasswordPolicy;
  password: string;
  className?: string;
}) {
  const requirements = describePasswordPolicy(policy, password);
  if (requirements.length === 0) return null;

  return (
    <ul className={`space-y-1 text-xs ${className}`} aria-label="Password requirements">
      {requirements.map((requirement) => (
        <li
          key={requirement.id}
          className={`flex items-center gap-1.5 ${
            requirement.met ? 'text-success-foreground' : 'text-muted-foreground'
          }`}
        >
          {requirement.met ? (
            <Check className="h-3.5 w-3.5 shrink-0" aria-hidden />
          ) : (
            <X className="h-3.5 w-3.5 shrink-0" aria-hidden />
          )}
          <span>{requirement.label}</span>
          <span className="sr-only">{requirement.met ? ' — met' : ' — not yet met'}</span>
        </li>
      ))}
    </ul>
  );
}
